import { ArrowRight, Calendar } from 'lucide-react'

export function SectionCTA() {
  return (
    <section className="relative flex min-h-screen items-center justify-center bg-paper">
      <div className="container-narrow py-20 text-center">
        <h2 className="display text-[44px] leading-[1.08] text-ink-900 md:text-[80px]">
          <span className="md:whitespace-nowrap">Ship agents with</span>{' '}
          <span className="text-rainbow-shift">confidence.</span>
        </h2>
        <p className="mx-auto mt-7 max-w-[560px] text-[17.5px] leading-[1.55] tracking-[-0.005em] text-ink-500 md:text-[19px]">
          Thirty minutes with a solutions engineer and we'll get LangWatch live
          on your stack, end to end.
        </p>
        <div className="mt-10 flex flex-col items-center gap-4">
          <a
            href="/get-a-demo"
            className="group inline-flex items-center justify-center gap-2.5 rounded-full bg-ink-900 px-9 py-5 text-[16px] font-semibold tracking-[-0.005em] text-paper shadow-[0_14px_32px_-14px_var(--color-brand-500)/18,inset_0_1px_0_0_rgba(255,255,255,0.10)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-ink-700 hover:shadow-[0_18px_36px_-14px_var(--color-brand-500)/26,inset_0_1px_0_0_rgba(255,255,255,0.14)] active:translate-y-0"
          >
            <Calendar className="h-[18px] w-[18px]" />
            Talk to an engineer
            <ArrowRight className="h-[18px] w-[18px] transition-transform duration-200 group-hover:translate-x-1" />
          </a>
          <a
            href="https://app.langwatch.ai/"
            target="_blank"
            rel="noreferrer"
            className="text-[13.5px] text-ink-500 underline-offset-4 transition-colors hover:text-ink-800 hover:underline"
          >
            or start free in 5 minutes
          </a>
        </div>
      </div>
    </section>
  )
}
